import React, { useContext } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Layout from "../Layout";
import Launcher from "../components/Launcher";
import { WidgetContext } from "../store/widgetContext";
import { useBootstrap } from "./bootstrap/useBootstrap";
import { isOperatorsOnly } from "../utils/responder";

const PrivateRoutes = (props) => {
	const context = useContext(WidgetContext);
	const { loading, verified } = useBootstrap(props);
	// An "Operators only" channel has no agent to wait for (86bcj1kba).
	const agentReady = !!context.assistant || isOperatorsOnly(context.widget);

	if (!context.widget || !agentReady || loading || !verified) {
		return <></>;
	}

	return (
		<Routes>
			<Route path="/home" element={<Layout {...props}><Launcher {...props} /></Layout>} />
			<Route path="*" element={<Navigate to="/private/home" replace />} />
		</Routes>
	);
};

export default PrivateRoutes;
